import { Transform } from 'class-transformer';
import { Model } from './model';

export interface PaymentTimingInsights {
  average_days_to_pay: number;
  days_past_due_avg: number;
  on_time_payment_rate: number;
}

export interface EmailResponsivenessInsights {
  average_response_time: number; // in duration of minutes
  peak_response_day: number; // 0-6 (Sunday-Saturday)
  peak_response_time: number; // 0-23 (24-hour format)
}

export interface CallResponsivenessInsights {
  connection_rate: number;
}

export interface CommunicationPreferencesInsights {
  average_followups_needed: number;
  most_responsive_contact: string;
}

export class PartnerInsights extends Model {
  @Transform(({ value }) => (value ? new Date(value) : null))
  analysis_period_start: Date | null;

  @Transform(({ value }) => (value ? new Date(value) : null))
  analysis_period_end: Date | null;

  payment_timing: PaymentTimingInsights | null;
  email_responsiveness: EmailResponsivenessInsights | null;
  call_responsiveness: CallResponsivenessInsights | null;
  communication_preferences: CommunicationPreferencesInsights | null;

  get hasAnyInsights(): boolean {
    return Boolean(
      this.payment_timing ||
      this.email_responsiveness ||
      this.call_responsiveness ||
      this.communication_preferences,
    );
  }
}
